import { ActionListNavItem } from '../interfaces/ActionListNavItem';

export default class ActionListNavService {
  static hasItems(items: ActionListNavItem[]): boolean {
    return items.length > 0;
  }
}
